/**
 * @generated SignedSource<<7aa265a078cd9158a01d0b552d67fd54>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type EntityKind = "COMPANY" | "PERSON" | "%future added value";
export type CreateEntityInput = {
  clientMutationId?: string | null | undefined;
  email?: string | null | undefined;
  kind: EntityKind;
  name: string;
  notes?: string | null | undefined;
  phone?: string | null | undefined;
};
export type OpsOwnersPageCreateMutation$variables = {
  input: CreateEntityInput;
};
export type OpsOwnersPageCreateMutation$data = {
  readonly createEntity: {
    readonly entity: {
      readonly id: string;
      readonly name: string;
    } | null | undefined;
    readonly userErrors: ReadonlyArray<{
      readonly message: string;
    }>;
  } | null | undefined;
};
export type OpsOwnersPageCreateMutation = {
  response: OpsOwnersPageCreateMutation$data;
  variables: OpsOwnersPageCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateEntityPayload",
    "kind": "LinkedField",
    "name": "createEntity",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Entity",
        "kind": "LinkedField",
        "name": "entity",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "userErrors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OpsOwnersPageCreateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OpsOwnersPageCreateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e58738c90fa295058898dacb477e89c4",
    "id": null,
    "metadata": {},
    "name": "OpsOwnersPageCreateMutation",
    "operationKind": "mutation",
    "text": "mutation OpsOwnersPageCreateMutation(\n  $input: CreateEntityInput!\n) {\n  createEntity(input: $input) {\n    entity {\n      id\n      name\n    }\n    userErrors {\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f846e677c0384d6b035ef1f95a754449";

export default node;
